
import ChangePasswordTab from "../components/changePasswordTab"
import MyAccountTab from "../components/myAccountTab"
import TwoStepTab from "../components/twoStepTab"


export const getDetailViewConfig = async(data) => {
    return {
        titleConfig: {
            breadcrumbs: false,
            breadcrumbsReplacment: 'Account Settings',
            title: 'My Account ',
        },
        type: 'users',
        title: 'Account',
        tabs: [
            {title: 'My Account', component:MyAccountTab},
            {title: 'Change Password', component:ChangePasswordTab},
            {title: 'Two-step sign-in', component:TwoStepTab},
        ],

    }
}